import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M.715 15v-2.625A2.625 2.625 0 0 1 3.34 9.75h4.375m4.062 2.844-1.875-1.75m0 0 1.875-1.75m-1.875 1.75h4.813m-5.25-7.219a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0"
    }, null, -1)
  ])))
}
export default { render: render }